import _ from 'lodash';

import menuAccess from '../config/menu/access';

const { UserPermissions } = require('./user-permissions').default;

const replaceMenuComponentUnauthorized = function replaceMenuComponentUnauthorized(menuItem) {
  const replacedMenuItem = Object.assign({}, menuItem);
  replacedMenuItem.component = 'no-match/NoAccess';
  return replacedMenuItem;
};

const getRoutes = function getRoutes(activeOnly = false) {
  const retRoutes = [];

  _.each(menuAccess, (item) => {
    let menuItem = Object.assign({}, item);
    if (activeOnly === true && menuItem.inactive === true) {
      return;
    }
    if (UserPermissions.hasPermissions(menuItem.permission) === false) {
      menuItem = replaceMenuComponentUnauthorized(menuItem);
    }
    if (_.has(menuItem, 'component')) {
      if (_.has(menuItem, 'childRoutes')) {
        const retChildRoutes = [];
        _.each(menuItem.childRoutes, (childRoute) => {
          let childMenuItem = Object.assign({}, childRoute);
          if (UserPermissions.hasPermissions(childMenuItem.permission) === false) {
            childMenuItem = replaceMenuComponentUnauthorized(childMenuItem);
          }
          if (_.has(childMenuItem, 'component')) {
            retChildRoutes.push(childMenuItem);
          }
        });
        menuItem.childRoutes = retChildRoutes;
      }
      retRoutes.push(menuItem);
    }
  });

  return retRoutes;
};

export default {
  getRoutes,
};



// WEBPACK FOOTER //
// ./src/utils/routes.js